<!-- <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js" integrity="sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q" crossorigin="anonymous"></script> -->

<div class="container">
  <div id="notes-detail" class="content">
    <div *ngIf="notes && notes.length == 0" style="padding: 50px 0px 75px; text-align:center">
      <p>
        <h2>No release notes found matching search.</h2>
    </div>
    <div *ngIf="notes && notes.length > 0" class="notes-detail-title">
      <span>{{notes[0].releaseDate | date: "MMMM, yyyy"}}</span>
      <span>Release Notes</span>
    </div>
    <div class="card-deck" *ngFor='let note of notes; let i = index'>
      <div class="col-md-12 detail">
        <span class='hotfix' *ngIf='note.isHotfix'>hotfix!</span>
        <button [id]="['toggle'+i]" class="btn btn-link" type="button" [attr.aria-expanded]="showNote[i]" [attr.aria-controls]="['#note-detail' + i]" (click)="showNote[i] = !showNote[i];">
          <span>{{showNote[i] ? "Hide" : "Show"}} {{note.releaseDate | date: "MMMM d, yyyy"}} | Ver. {{note.versionNum}}</span>
        </button>
        <div [id]="['note'+i]" [ngbCollapse]="!showNote[i]">
          <div id={{note.dateCreated}}>
            <div class="Note-Date">
              <div class="Note-D">{{note.releaseDate | date: "d"}}</div>
              <div class="Note-M">{{note.releaseDate | date: "MMM"}}</div>
              <div class="Note-y">{{note.releaseDate | date: "yyyy"}}</div>
            </div>
            <div class="Note-Date-mobile">
              {{note.releaseDate | date: "MMMM d, yyyy"}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
